<template>
  <section
    class="flex items-center justify-center z-9"
    :class="{ 'background-opacity absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 transform-gpu will-change-transform': isAbsolute }"
  >
    <div class="grid justify-items-center gap-y-9">
      <div class="flex h-[200px] w-[200px] items-center justify-center rounded-full bg-black">
        <wui-icon
          name="pause"
          class="h-20! w-20! text-white!"
        />
      </div>
      <p
        class="rounded-full bg-black px-12 py-1 text-2432 text-white"
      >
        {{ text ? text : $t('common.conferenceSuspended') }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'

withDefaults(defineProps<{
  isAbsolute?: boolean,
  text?: string
}>(), {
  isAbsolute: false,
  text: '',
})
</script>

<style>
.background-opacity {
    background-color: rgba(102, 102, 102, 0.5);
}
</style>
